import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import {
	intern_toggle_modal_color_open,
	intern_toggle_override_color
} from '../../actions'
import {ReactComponent as XClose} from '../../assets/svg/x_close.svg'


const InternModusColorOverlay = () => {
    const { t } = useTranslation();
	
	const dispatch = useDispatch()
	
	const modal_color_open = useSelector(state => state.general.intern_ui.modal_color_open);
    const override_color_bg = useSelector(state => state.general.intern_config.override_color_bg)
	
	// label_color is not used
	const color_buttons = [
        { bg_color: null, label_color: "#ffffff", class: 'color-0'},
		{ bg_color: "#EB0000", label_color: "#ffffff", class: 'color-1'},
		{ bg_color: "#ff9a00", label_color: "#ffffff", class: 'color-2'},
		{ bg_color: "#ffe001", label_color: "#181716", class: 'color-3'},
		{ bg_color: "#30c059", label_color: "#ffffff", class: 'color-4'},
		{ bg_color: "#0361ec", label_color: "#ffffff", class: 'color-5'},
		{ bg_color: "#aa00ec", label_color: "#ffffff", class: 'color-6'},
		{ bg_color: "#000000", label_color: "#ffffff", class: 'color-7'},
	]
	
	const color_clicked = (id) => {
		const bg_color = color_buttons[id].bg_color
		const label_color = color_buttons[id].label_color
		dispatch(intern_toggle_override_color(bg_color, label_color))
	}

    const close_clicked = (e) => {
		e.preventDefault()
        dispatch(intern_toggle_modal_color_open(false))
    }

    const modal_class = () => {
        return modal_color_open ? 'mini-dialog-overlay show' : 'mini-dialog-overlay';
    }

    const is_active = (color) => {
        return override_color_bg === color? true : false;
    }

	// @TODO: the current choosen color is not marked, perhaps we need that?
    return (
        <>
            <div className={modal_class()} tabIndex="-1" aria-modal="true" role="dialog">
                <div className="mini-dialog-overlay-content">
                    <div className="color-buttons">
                    	{color_buttons.map((color_btn, index) => (
	                        <button className="color-button" 
	                        		key={`color-btn-${index}`}
	                        		onClick={() => color_clicked(index)}>
	                            <div className={`color-circle ${color_btn.class} ${is_active(color_btn.bg_color)? 'active': ''} ${override_color_bg}`}></div>
	                        </button>
                        ))}
                    </div>
                </div>
                <div className="mini-dialog-overlay-close-handler">
                    <button className="close-handler" onClick={close_clicked}>
                        <span className="visuallyhidden">{t("Farben schliessen")}</span>
                        <div className="close-icon">
                            <div className="circle"></div>
                            <XClose />
                        </div>
                    </button>
                </div>
            </div>
        </>
    )

}

export default InternModusColorOverlay